<template>
  <div>
    <t-modal
      :name="mid"
      variant="subscription"
      :hideCloseButton="true"
      :disableBodyScroll="true"
      ref="popup"
    >
      <div class="relative">
        <a href="#" @click.prevent="exportToPDF" class="out-modalbox">
          <img src="@/assets/placeholder/download.svg" alt="Download PDF" />
          <span>Download as PDF</span>
        </a>
        <section ref="document">
          <transaction-card
            :amount="transaction.amount"
            :currencySymbol="getCurrencySymbol"
          />
          <transaction-list
            :title="$t('components.transactionPopup.paymentFor')"
            :value="transaction.payment_for"
            icon="fas fa-credit-card mr-3 green"
            value_class="value_icon"
          />

          <transaction-list
            :title="$t('components.transactionPopup.paymentMethod')"
            :value="transaction.payment_method"
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.payerName')"
            :value="`--`"
            value_class="normal_value"
          >
            <router-link
              v-if="transaction.user"
              class="font-bold text-blue-600"
              :to="{
                name: getViewName(transaction.user.role_name),
                params: { id: transaction.user.id },
              }"
              target="_blank"
            >
              {{ transaction.user.full_name }}
            </router-link>
          </transaction-list>

          <!-- <transaction-list
          title="Payer ID"
          :value="transaction.user ? transaction.user.id : '--'"
          value_class="blue_value"
        /> -->

          <transaction-list
            :title="$t('components.transactionPopup.payerContact')"
            :value="transaction.user ? transaction.user.phone_number : '--'"
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.transactionTime')"
            :value="
              getFormattedDateTime(transaction.date, 'D MMM, YYYY hh:mm:ss a')
            "
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.transactionID')"
            :value="transaction.id"
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.taxID')"
            :value="transaction.tax_id ? transaction.tax_id : '--'"
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.refundedAmount')"
            :value="
              transaction.is_refunded
                ? getFormattedPrice(transaction.amount)
                : '--'
            "
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.refundStatus')"
            :value="
              transaction.refund_status && transaction.refund_status !== ''
                ? transaction.refund_status
                : '--'
            "
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.clientIP')"
            :value="
              transaction.client_ip_address
                ? transaction.client_ip_address
                : '--'
            "
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.fingerprint')"
            :value="
              transaction.payment_method_details &&
              transaction.payment_method_details.fingerprint
                ? transaction.payment_method_details.fingerprint
                : '--'
            "
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.cardOriginCountry')"
            :value="
              transaction.payment_method_details &&
              transaction.payment_method_details.card_origin_country
                ? transaction.payment_method_details.card_origin_country
                : '--'
            "
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.cardExpireDate')"
            :value="
              transaction.payment_method_details &&
              transaction.payment_method_details.expiry
                ? getFormattedDateTime(
                    transaction.payment_method_details.expiry,
                    'D MMM, YYYY'
                  )
                : '--'
            "
            value_class="normal_value"
          />

          <transaction-list
            :title="$t('components.transactionPopup.cardExtraDetails')"
            :value="
              transaction.payment_method_details &&
              transaction.payment_method_details.extra_detail
                ? transaction.payment_method_details.extra_detail
                : '--'
            "
            value_class="normal_value"
          />

          <cost-message-box
            :message="
              $t('components.transactionPopup.transactionAmount', {
                currencySymbol: getCurrencySymbol,
                transactionAmount: transaction.amount,
              })
            "
            width="width-50"
          />
        </section>
        <div class="flex items-center justify-end px-4 py-4 mt-8">
          <anchor-button variant="secondary" @click="$refs.popup.hide()">
            {{ $t('components.stepNavigation.close') }}
          </anchor-button>
        </div>
      </div>
    </t-modal>
  </div>
</template>

<script>
import { EventBus } from '@/utils/EventBus'
import { TransactionConfig } from '@/config/TransactionConfig'
import html2pdf from 'html2pdf.js'

import TransactionCard from '@/components/cards/TransactionCard.vue'
import CostMessageBox from '@/composites/trip/shared/CostMessageBox'
import TransactionList from '@/composites/transaction/shared/TransactionList.vue'

import AnchorButton from '@/components/form/AnchorButton.vue'
// import OtoTypography from "@/components/ui/OtoTypography.vue";
import { getFormattedDateTime } from '@/utils/datetime'

export default {
  name: 'ViewTransactionPopup',
  components: {
    AnchorButton,
    // OtoTypography,
    TransactionCard,
    CostMessageBox,
    TransactionList,
  },
  data() {
    return {
      mid: TransactionConfig.events.viewingData,
      transaction: {},
    }
  },
  computed: {
    getCurrencySymbol() {
      if (this.transaction.currency) {
        return this.transaction.currency.symbol
      }

      return this.$org.default_currency.symbol
    },
  },
  mounted() {
    EventBus.$on(TransactionConfig.events.viewingData, (item) => {
      console.log(item)
      this.transaction = item
      console.log(this.transaction)
    })
  },
  methods: {
    getFormattedDateTime,

    getViewName(role) {
      const ROLE_TO_VIEW_MAP = {
        '--': 'ViewRiderUserProfile',
      }

      return ROLE_TO_VIEW_MAP[role] || 'ViewOrganizationUserProfile'
    },
    getFormattedPrice(rawPrice) {
      let _price = rawPrice

      if (typeof rawPrice !== 'number') {
        _price = parseFloat(rawPrice).toFixed(2)

        if (isNaN(_price)) {
          return '--'
        }
      } else {
        _price = rawPrice.toFixed(2)
      }

      return `${this.getCurrencySymbol()} ${_price}`
    },
    exportToPDF() {
      console.log('Document ref:', this.$refs.document)
      if (!this.$refs.document) {
        console.error('Error: Document reference is undefined')
        this.$notify(
          {
            group: 'generic',
            type: 'error',
            title: 'Export Failed',
            text: 'Unable to generate PDF: Content not found.',
          },
          5000
        )
        return
      }
      html2pdf(this.$refs.document, {
        margin: [0.5, 1, 0.5, 0.5],
        filename: `transaction-${this.transaction.id || 'unknown'}.pdf`,
        image: { type: 'jpeg', quality: 0.9 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'A4', orientation: 'portrait' },
      }).catch((error) => {
        console.error('PDF generation error:', error)
        this.$notify(
          {
            group: 'generic',
            type: 'error',
            title: 'Export Failed',
            text: 'An error occurred while generating the PDF.',
          },
          5000
        )
      })
    },
  },
}
</script>

<style lang="scss">
.out-modalbox {
  background: #fff;
  padding: 7px 10px;
  z-index: 50;
  display: flex;
  transition: all 0.3s ease-in-out;

  // the position values below are placed by experimenting / simulating responsiveness on browser
  position: fixed !important;
  top: 50%;
  right: 0;
  @media (min-width: 850px) {
    right: 1%;
  }
  @media (min-width: 950px) {
    right: 5%;
  }
  @media (min-width: 1200px) {
    right: 12%;
  }
  @media (min-width: 1500px) {
    top: 45%;
    right: 14%;
  }

  span {
    transition: all 0.3s ease-in-out;
    font-size: 0;
  }
  &:hover {
    span {
      display: inline-block;
      width: auto;
      margin-left: 15px;
      right: 0;
      position: relative;
      font-size: 13px;
    }
  }
  & + .out-modalbox {
    top: calc(50% + 50px);
  }
  @media (min-width: 1500px) {
    & + .out-modalbox {
      top: calc(45% + 50px);
    }
  }
}
</style>
